import { Component, Children } from 'react';
import createObservableSubject from 'utils/helpers/create-observable-subject';

export const observableMount = createObservableSubject();

export const MOUNTED = 'mounted';
export const UNMOUNTED = 'unmounted';

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy class component (baseline)
class MountNotifier extends Component {
    componentDidMount() {
        observableMount.notify(MOUNTED);
    }

    componentWillUnmount() {
        observableMount.notify(UNMOUNTED);
    }

    render() {
        return Children.only(this.props.children);
    }
}

export default MountNotifier;
